import * as Reducers from './help-faq.reducers';

export const HelpFaqReducers = {
  Reducers,
};
